var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 30,
    viewBox: "0 0 34 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3.25001C1.25 2.14544 2.14543 1.25001 3.25 1.25001L11.8061 1.25C12.4038 1.25 12.9701 1.51726 13.35 1.97859L16.15 5.37856C16.5299 5.83989 17.0962 6.10715 17.6938 6.10715H30.25C31.3546 6.10715 32.25 7.00258 32.25 8.10715V26.25C32.25 27.3546 31.3546 28.25 30.25 28.25H3.25C2.14543 28.25 1.25 27.3546 1.25 26.25V3.25001Z",
    stroke: "white",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 6.25L14.25 8.75H1.25",
    stroke: "white",
    strokeWidth: 2.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilesWhite);
export default __webpack_public_path__ + "static/media/files-white.c34609ede4ebd488f0cfc9a8675969f1.svg";
export { ForwardRef as ReactComponent };